import React from "react";
import "./App.css";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import { Routes, Route } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import Home from "./components/Home";
import Layout from "./Layout";
// Disabled route imports are intentionally kept here for easy re-enablement.
// import { Navigate } from "react-router";
import MarketingLayout from "./components/MarketingLayout";
import ManageAgent from "./components/Agent/ManageAgent";
import AgentLayout from "./components/Agent";
import ListAgents from "./components/Agent/ListAgents";
import ViewAgent from "./components/Agent/ViewAgent";
import ChatInterface from "./components/Chat/ChatInterface";
import SettingsInterface from "./components/Settings/SettingsInterface";
import Landing from "./components/Landing";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import ContactUs from "./components/ContactUs";
import { theme } from "./theme/theme";
import LandingHybrid from "./components/LandingHybrid";
import ScheduledMessages from "./components/ScheduledMessages/ScheduledMessages";
import AppAnalytics from "./components/AppAnalytics";
import BlogsPage from "./components/Blogs/BlogsPage";
import BlogViewerPage from "./components/Blogs/BlogViewerPage";
import ToolsPage from "./components/Tools/ToolsPage";
import ServicesPage from "./components/Services/ServicesPage";
// import AdminOnboardingPage from "./components/Onboarding/AdminOnboardingPage";
import CustomerOnboardingForm from "./components/Onboarding/CustomerOnboardingForm";
import SuperAdminPage from "./components/SuperAdmin/SuperAdminPage";
import FlowBuilderPage from "./components/FlowBuilder/FlowBuilderPage";
import ShopKaBotStorefront from "./components/Commerce/ShopKaBotStorefront";
import PublicProductStore from "./components/Commerce/PublicProductStore";
const VideoAdsPage = React.lazy(() => import('./components/VideoAds/VideoAdsPage'));

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="App">
          <AppAnalytics />
          <Box
            component="div"
            sx={{
              flex: 1,
              width: "100%",
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Routes>
              <Route path="/" element={<LandingHybrid />} />
              <Route path="/buy" element={<ShopKaBotStorefront />} />
              <Route path="/video-ads" element={<React.Suspense fallback={<p role="status">Loading video studio…</p>}><VideoAdsPage /></React.Suspense>} />
              <Route path="/store/:slug" element={<PublicProductStore />} />
              <Route path="/:slug" element={<PublicProductStore />} />
              <Route path="/original-start" element={<Landing />} />
              <Route
                path="/onboard/:businessSlug/:inviteToken"
                element={<CustomerOnboardingForm />}
              />

              <Route element={<MarketingLayout />}>
                <Route path="/blogs" element={<BlogsPage />} />
                <Route path="/blogs/:slug" element={<BlogViewerPage />} />
                <Route path="/tools" element={<ToolsPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/contact-us" element={<ContactUs />} />
                {/* Temporarily disabled routes. Keep these declarations for re-enablement.
                <Route path="/consultation-book" element={<Navigate to="/contact-us" replace />} />
                <Route path="/booking" element={<Navigate to="/contact-us" replace />} />
                <Route path="/book-a-demo" element={<Navigate to="/contact-us" replace />} />
                <Route path="/booking-success" element={<Navigate to="/contact-us" replace />} />
                */}
              </Route>

              <Route element={<Layout />}>
                <Route path="/original-dashboard" element={<Home />} />
                <Route path="/agent" element={<AgentLayout />}>
                  <Route index element={<ListAgents />} />
                  <Route path="new" element={<ManageAgent />} />
                  <Route path="edit/:agentId" element={<ManageAgent />} />
                  <Route path="view/:agentId" element={<ViewAgent />} />
                </Route>

                <Route path="/campaign" element={<SettingsInterface workspace="campaigns" />} />

                <Route path="/chat" element={<ChatInterface />} />

                <Route path="/settings" element={<SettingsInterface />} />
                <Route path="/super-admin" element={<SuperAdminPage />} />
                <Route path="/chatbot-builder" element={<FlowBuilderPage />} />
                <Route path="/chatbot-builder/:businessId" element={<FlowBuilderPage />} />

                <Route
                  path="/scheduled_messages"
                  element={<ScheduledMessages />}
                />

                {/* Temporarily disabled routes. Keep these declarations for re-enablement.
                <Route path="/dashboard" element={<Home />} />
                <Route path="/onboarding" element={<AdminOnboardingPage />} />
                */}
              </Route>

              {/* Temporarily disabled routes. Keep these declarations for re-enablement.
              <Route path="/start" element={<LandingHybrid />} />
              <Route path="/pricing" element={<ShopKaBotStorefront />} />
              */}
            </Routes>
        </Box>
      </div>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
